import React, { useEffect, useState } from "react";
import { Form, Label, Card, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import Required from "../../myComponents/validate/Required";
import useLogout, { ValidateImgPdf } from "../../utils/Utils";
import { deleteImageAPI, imageListAPI, uploadImageAPI } from "../../api/imgupload";
import { BiCopy, BiMinus, BiPlus, BiTrash } from "react-icons/bi";
import { toast } from "react-toastify";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import { FaFilePdf, FaRegImage } from "react-icons/fa";
import ViewImgAndPdf from "../../myComponents/modals/ViewImgAndPdf";
import ConfirmDeleteModal from "../../myComponents/modals/ConfirmDeleteModal";
import CopyToClipboard from "react-copy-to-clipboard";
import { decrypt, encryptFormData } from "../../utils/Encrypt";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import Content from "../../layout/content/Content";
const UploadImage = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm();
  const logout = useLogout();
  const IMAGE_BASE_URL = localStorage.getItem("IMAGE_BASE_URL");
  const [showDelModal, setShowDelModal] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [titleName, setTitleName] = useState("");
  const [fileType, setFileType] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [copy, setCopy] = useState(false);

  const handleCopy = () => {
    setCopy(true);
    setTimeout(() => setCopy(false), 2000);
  };
  const getFileTypeFromUrl = (url) => {
    const fileExtension = url.split(".").pop().split(/#|\?/)[0];
    return fileExtension.toLowerCase();
  };
  const toggleImageModal = () => {
    setModalOpen(true);
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const handleImageClick = (index, image, inputName, fileType) => {
    setCurrentImageIndex(index);
    // setModalImages([image]);
    // toggleImageModal();
    setTitleName(inputName);
    setFileType(fileType);
    if (fileType === "pdf") {
      setModalImages([image]); // Here, 'file' could be the URL or Blob of the PDF
    } else {
      setModalImages([image]); // Here, 'file' could be the URL of the image
    }

    toggleImageModal();
  };

  const renderContent = (fileType, fileUrl) => {
    const lowerCaseFileType = fileType.toLowerCase();
    if (["png", "jpg", "jpeg", "jfif"].includes(lowerCaseFileType)) {
      return (
        <>
          <div onClick={() => handleImageClick(0, fileUrl, "", fileType)}>
            <img style={{ width: "50px" }} src={fileUrl} />
            <p></p>
          </div>
        </>
      );
    } else if (lowerCaseFileType === "pdf") {
      return (
        <Button
          outline
          id="img"
          color="danger"
          type="button"
          onClick={() => handleImageClick(0, fileUrl, "", fileType)}
          size="sx"
        >
          <FaFilePdf style={{ height: "1rem", width: "1rem" }} />
        </Button>
      );
    }
    return null;
  };

  useEffect(() => {
    imageList();
  }, []);

  const imageList = () => {
    imageListAPI()
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error fetching data");
      });
  };

  const [column, setColumn] = useState([
    {
      name: "Image /Pdf Ttile",
      selector: (row) => `${row?.image_alt}${" "}`,
      sortable: true,
    },
    {
      name: "Image /Pdf Ttile Hindi",
      selector: (row) => row?.hn_image_alt,
      sortable: true,
    },
    {
      name: "Document",
      selector: (row) => {
        const fileUrl = `${IMAGE_BASE_URL}${row?.document}`;
        const fileType = getFileTypeFromUrl(fileUrl);
        const lowerCaseFileType = fileType.toLowerCase();
        if (["png", "jpg", "jpeg", "jfif"].includes(lowerCaseFileType)) {
          return (
            <>
              <div className="upload-image-div" onClick={() => handleImageClick(0, fileUrl, "", fileType)}>
                <img className="image-upload" src={fileUrl} style={{width:"100px", height:"auto",cursor:"pointer"}} />
               
              </div>
            </>
          );
        } else if (lowerCaseFileType === "pdf") {
          return (
            <div className="upload-image-div">
              <Button
                outline
                id="img"
                color="danger"
                type="button"
                onClick={() => handleImageClick(0, fileUrl, "", fileType)}
                size="xxl"
                data-toggle="tooltip"
                data-placement="top"
                title="View PDF"
              >
                <FaFilePdf style={{ height: "1rem", width: "1rem" }} />
              </Button>
            </div>
          );
        }
        return null;
      },
      sortable: true,
    },
    {
      name: "Action",
      wrap: true,
      selector: (row) => {
        const fileUrl = `${IMAGE_BASE_URL}${row?.document}`;
        return (
          <>
            <div>
              {copy ? (
                <span>Copied</span>
              ) : (
                <CopyToClipboard text={fileUrl} onCopy={handleCopy}>
                  <Button data-toggle="tooltip" data-placement="top" title="Copy URL">
                    <BiCopy />
                  </Button>
                </CopyToClipboard>
              )}
            </div>
            {/* <Button
                            outline
                            size={`xs`}
                            className={`mx-2`}
                            onClick={() => handleDelete(row)}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete Image/PDF"
                        >
                            {" "}
                            <BiTrash />
                        </Button> */}
          </>
        );
      },
      sortable: true,
    },
  ]);

  const confirmDeleteImage = () => {
    const bodyData = {
      id: watch("rowData")?.id,
    };
    deleteImageAPI(bodyData)
      .then((res) => {
        if (res.data.status == "success") {
          setIsLoading(false);
          imageList();
          setShowDelModal(false);
          toast.success(res.data.message);
        } else if (res.data.status == "failed") {
          toast.error(res.data.message);
          setIsLoading(false);
        } else if (res.data.status == "expired") {
          logout(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleDelete = (row) => {
    setValue("rowData", row);
    setShowDelModal(true);
  };
  const [LabelName, setLabelName] = useState("Image Alt");
  const [LabelNameHn, setLabelNameHn] = useState("Image Alt हिंदी");

  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const fileType = file.type;
      // Update label based on file type
      if (fileType === "application/pdf") {
        setLabelName("PDF Title");
        setLabelNameHn("PDF Title हिंदी");
        setValue("image_alt", "");
        setValue("image_alt_hn", "");
      } else {
        setLabelName("Image Alt");
        setLabelNameHn("Image Alt हिंदी");
        setValue("image_alt", "");
        setValue("image_alt_hn", "");
      }
      ValidateImgPdf(file, (isValid) => {
        if (isValid) {
          clearErrors(fieldName);
          trigger(fieldName);
        } else {
          setError(fieldName, {
            type: "manual",
            message: "Invalid file type. Only PNG, JPEG, and PDF files are allowed.",
          });
          e.target.value = ""; // Clear the input field
        }
      });
    }
  };

  const onFormSubmit = async (data) => {
    const rawFormData = new FormData();
    const file = data?.Image?.[0];

    if (file) {
      const fileType = file.type;

      // Append file directly (NOT encrypted)
      rawFormData.append("document", file);

      // FormData to be encrypted
      const encryptFd = new FormData();
      encryptFd.append("module", "Image Upload");

      if (fileType === "application/pdf") {
        encryptFd.append("title", data?.image_alt);
        encryptFd.append("hn_title", data?.image_alt_hn);
      } else {
        encryptFd.append("image_alt", data?.image_alt);
        encryptFd.append("hn_image_alt", data?.image_alt_hn);
      }

      try {
        const encryptedData = await encryptFormData(encryptFd); // returns encrypted blob/string
        rawFormData.append("zero", encryptedData); // encrypted data appended

        uploadImageAPI(rawFormData)
          .then((res) => {
            const status = decrypt(res.data.status); // decrypt status
            if (status === "success") {
              setIsOpen(false);
              imageList();
              reset();
              setIsLoading(false);
              toast.success(res.data.message);
            } else if (status === "failed") {
              toast.error(res.data.message);
              setIsLoading(false);
            } else if (status === "expired") {
              logout(res.data.message);
            }
          })
          .catch((errors) => {
            console.error(errors);
            setIsLoading(false);
          });
      } catch (error) {
        console.error("Encryption error:", error);
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <Head title={"Image Upload"} />
      <Content>
        <div className="container-fluid ">
          <BlockHead size={`sm`}>
            <BlockBetween>
              <BlockHeadContent>
                <BlockTitle page tag="h3">
                  {"Image Upload"}
                </BlockTitle>
              </BlockHeadContent>
              <BlockHeadContent>
                <div className="">
                  <Button
                    color="primary"
                    outline
                    className={`  me-n1`}
                    onClick={() => {
                      setIsOpen((pre) => !pre);
                      reset();
                    }}
                  >
                    <Icon name={isOpen ? "minus" : "plus"} />
                  </Button>
                </div>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>

          <Block>
            <Row className={`g-gs`}>
              {isOpen && (
                <PreviewAltCard>
                  <Form onSubmit={handleSubmit(onFormSubmit)}>
                    <Row className={`g-gs`}>
                      <Col md="4" sm="3" xxl="3">
                        <div className="form-group">
                          <Label className="form-label" htmlFor="Image">
                            {"Image /PDF Upload"} <Required />
                          </Label>
                          <input
                            type="file"
                            className="form-control"
                            id="Image"
                            {...register("Image", {
                              required: {
                                value: true,
                                message: "Image /PDF is required",
                              },
                            })}
                            onChange={(e) => handleImageChange(e, "Image")} // Ensure correct field name
                          />
                          {errors.Image && <span className="invalid">{errors.Image.message}</span>}
                        </div>
                      </Col>
                      {/*Image Alt */}
                      <Col md="4" sm="3" xxl="3">
                        <div className="form-group">
                          <Label className="form-label" htmlFor="image_alt">
                            {LabelName} <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              placeholder={"Enter Image Title/Tag"}
                              type="text"
                              id="image_alt"
                              {...register("image_alt", {
                                required: {
                                  value: true,
                                  message: "Image/pdf Title is required",
                                },
                                minLength: {
                                  value: 3,
                                  message: "Title must be at least 2 characters long",
                                },
                                maxLength: {
                                  value: 50,
                                  message: "Title cannot exceed 50 characters",
                                },
                              })}
                              className="form-control"
                              value={watch("image_alt")}
                              onChange={(e) => {
                                setValue("image_alt", e.target.value);
                                trigger("image_alt"); // Trigger validation
                              }}
                            />
                            {errors.image_alt && <span className="invalid">{errors?.image_alt?.message}</span>}
                          </div>
                        </div>
                      </Col>{" "}
                      {/*Image Alt HN */}
                      <Col md="4" sm="3" xxl="3">
                        <div className="form-group">
                          <Label className="form-label" htmlFor="image_alt_hn">
                            {LabelNameHn} <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              placeholder={"छवि/pdf शीर्षक हिंदी में दर्ज करें"}
                              type="text"
                              id="image_alt_hn"
                              {...register("image_alt_hn", {
                                required: {
                                  value: true,
                                  message: "हिंदी में छवि/pdf शीर्षक आवश्यक है",
                                },
                                minLength: {
                                  value: 3,
                                  message: "शीर्षक हिंदी कम से कम 2 अक्षर लंबा होना चाहिए",
                                },
                                maxLength: {
                                  value: 50,
                                  message: "शीर्षक हिंदी 50 अक्षरों से अधिक नहीं हो सकता",
                                },
                              })}
                              className="form-control"
                              value={watch("image_alt_hn")}
                              onChange={(e) => {
                                setValue("image_alt_hn", e.target.value);
                                trigger("image_alt_hn");
                              }}
                            />
                            {errors.image_alt_hn && <span className="invalid">{errors?.image_alt_hn?.message}</span>}
                          </div>
                        </div>
                      </Col>{" "}
                      <Col md="2" className={``}>
                        <div className="form-group" style={{ marginTop: "25px" }}>
                          <Button disabled={isLoading} color="primary" size="md" type="submit">
                            {isLoading ? <Spinner size="sm" color="primary" /> : "Save"}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </PreviewAltCard>
              )}
            </Row>
          </Block>

          <MyDataTable data={data} columns={column} title={"Image Upload"} isLoading={isLoading} />
          <ViewImgAndPdf
            fileType={fileType}
            titleName={titleName}
            isOpen={modalOpen}
            toggleModal={toggleModal}
            images={modalImages}
            currentImageIndex={currentImageIndex}
            setCurrentImageIndex={setCurrentImageIndex}
          />
        </div>
        {/* Confirmation Delete Modal */}
        <ConfirmDeleteModal
          name={"Image"}
          isOpen={showDelModal}
          toggle={() => setShowDelModal(!showDelModal)}
          onConfirm={confirmDeleteImage}
        />
      </Content>
    </>
  );
};

export default UploadImage;
